import React, { useEffect, useState } from "react";
import { DialogWrapMedium } from "../../../controls/components/dialogWrap/DialogWrap";
import { InputOrderAdminTitle, UserFormServiceButtonClose } from "../../MyBooking/styled/DesStyled";
import {
	getPartnerPayoutLockAudit,
	PartnerPayoutLockAuditEntry,
} from "../../../../services/PartnerService";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import moment from "moment";

function actionLabel(action: string) {
	if (action === "lock") return "Locked";
	if (action === "unlock") return "Unlocked";
	if (action === "update_reason") return "Updated reason";
	return action;
}

export default function DialogPartnerPayoutLockAudit(props: {
	openDialog: boolean;
	onClose: () => void;
	partnerId: string | null;
	partnerName: string;
}) {
	const { openAlertDialog } = useAlertDialog();
	const [rows, setRows] = useState<PartnerPayoutLockAuditEntry[]>([]);
	const [total, setTotal] = useState(0);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!props.openDialog || !props.partnerId) {
			setRows([]);
			setTotal(0);
			return;
		}
		let cancelled = false;
		(async () => {
			setLoading(true);
			try {
				const res = await getPartnerPayoutLockAudit(props.partnerId, 100, 0);
				if (cancelled) return;
				setRows(res.data || []);
				setTotal(res.total || 0);
			} catch (err: unknown) {
				if (cancelled) return;
				const msg =
					err && typeof err === "object" && "response" in err
						? (err as { response?: { data?: { message?: string } } }).response?.data?.message
						: undefined;
				openAlertDialog?.(AlertType.Fail, msg || "Failed to load audit log.");
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [props.openDialog, props.partnerId, openAlertDialog]);

	return (
		<DialogWrapMedium open={props.openDialog} onClose={props.onClose}>
			<div style={{ padding: "8px 4px 0" }}>
				<InputOrderAdminTitle>Payout lock audit</InputOrderAdminTitle>
				<p style={{ fontSize: "13px", color: "#555", margin: "8px 0 12px" }}>
					<strong>{props.partnerName || "—"}</strong> &nbsp;·&nbsp; {total} event(s)
				</p>
				{loading ? (
					<p style={{ fontSize: "13px" }}>Loading…</p>
				) : rows.length === 0 ? (
					<p style={{ fontSize: "13px", color: "#888" }}>No audit entries yet.</p>
				) : (
					<div
						style={{
							maxHeight: 360,
							overflow: "auto",
							border: "1px solid #e0e0e0",
							borderRadius: 8,
						}}>
						<table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
							<thead>
								<tr style={{ background: "#f5f5f5" }}>
									<th style={{ textAlign: "left", padding: 8 }}>When (UTC)</th>
									<th style={{ textAlign: "left", padding: 8 }}>Action</th>
									<th style={{ textAlign: "left", padding: 8 }}>By</th>
									<th style={{ textAlign: "left", padding: 8 }}>Reason / note</th>
								</tr>
							</thead>
							<tbody>
								{rows.map((r) => (
									<tr key={r.id} style={{ borderTop: "1px solid #eee" }}>
										<td style={{ padding: 8, verticalAlign: "top", whiteSpace: "nowrap" }}>
											{r.createdAt ? moment.utc(r.createdAt).format("YYYY-MM-DD HH:mm:ss") : "—"}
										</td>
										<td style={{ padding: 8, verticalAlign: "top" }}>{actionLabel(r.action)}</td>
										<td style={{ padding: 8, verticalAlign: "top" }}>
											{r.changedByUser?.email || r.changedByUser?.fullName || r.changedByUserId || "—"}
										</td>
										<td style={{ padding: 8, verticalAlign: "top", wordBreak: "break-word" }}>
											{r.reason || "—"}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
				<div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
					<UserFormServiceButtonClose type="button" onClick={props.onClose}>
						Close
					</UserFormServiceButtonClose>
				</div>
			</div>
		</DialogWrapMedium>
	);
}
